<template>
  <va-dropdown
    class="color-dropdown"
    :offset="[0, 13]"
    position="bottom"
  >
    <template #anchor>
      <va-icon-color />
    </template>

    <va-dropdown-content class="color-dropdown__content pl-4 pr-4 pt-2 pb-2">
      <va-button-toggle
        v-model="selectedThemeName"
        :options="buttonToggleOptions"
        outline
        size="small"
        style="max-width: 100%;"
      />

      <table style="width: 100%;">
        <color-dropdown-item
          v-for="colorName in colorNames"
          :key="colorName"
          class="color-picker-dropdown"
          :color-name="colorName"
        />
      </table>
    </va-dropdown-content>
  </va-dropdown>
</template>

<script>
import { useColors } from 'vuestic-ui';
import VaIconColor from '@/components/icons/VaIconColor';
import ColorDropdownItem from './ColorDropdownItem';
import { computed } from 'vue';
import { THEME_NAMES } from '@/services/vuestic-ui/themes';

export default {
  components: {
    VaIconColor, ColorDropdownItem
  },
  emits: ['change-theme'],
  setup() {
    const { getColors } = useColors()

    const buttonToggleOptions = [
      { label: 'Light', value: THEME_NAMES.LIGHT },
      { label: 'Semi-Dark', value: THEME_NAMES.SEMI_DARK },
      // { label: 'Dark', value: THEME_NAMES.DARK },
      { label: 'Original', value: THEME_NAMES.ORIGINAL },
    ]

    //const { setTheme, themeName } = useTheme()
    const themeName = "";

    const colors = getColors()

    const selectedThemeName = computed({
      get: () => themeName.value//,
      //set: (newThemeName) => setTheme(newThemeName)
    })

    const colorNames = computed(() => Object.keys(colors))

    return { selectedThemeName, colorNames, buttonToggleOptions }
  }
}
</script>

<style lang="scss" scoped>

.color-dropdown {
  cursor: pointer;

  &__icon {
    position: relative;
    display: flex;
    align-items: center;
  }

  .va-dropdown__anchor {
    display: inline-block;
  }
}

.button-restore {
  display: flex;
  margin: 0.375rem auto;
}

table { 
  margin: 1rem 0;
}
</style>
